import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-content-menu.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-content-menu.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewContainerRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserInformationService } from "../../services/user/user-information.service";
import { AppControllerService } from "../../../app-controller.service";
import { ViewApplicationService } from "../../../application/view-application/view-application.service";
import { filter, Subject, switchMap, take, takeUntil } from "rxjs";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { WorkflowJobService } from "../../services/workflow-job/workflow-job.service";
import { RouterParamsService } from "../../services/route-params.service";
import { AlertType } from "../../models/alert";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { CancelApplicationConfirmationComponent } from "./cancel-application-confirmation/cancel-application-confirmation.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CurrentStepService } from "../../services/current-step/current-step.service";
import { ViewApplicationStepManagementConstants } from "../../../application/view-application/view-application-step-management/view-application-step-management.constants";
import { StrategyFinderComponent } from "../strategy-finder/strategy-finder.component";
import { ModuleConfig } from "../../models/module-config.model";
import { RequestStatusService } from "../../services/request-status/request-status.service";
import { ViewApplicationContentMenuConstants } from "./view-application-content-menu.constants";
let ViewApplicationContentMenuComponent = class ViewApplicationContentMenuComponent {
    router;
    userInformationService;
    routerParamsService;
    route;
    modalService;
    appController;
    jobService;
    currentStepService;
    changeDetectorRef;
    viewApplicationService;
    viewContainerRef;
    appControllerService;
    requestStatusService;
    pageHeading;
    menuItems;
    relativeLinks = true;
    selectedModule;
    TerminateApplicationText = "Withdraw Application";
    _destroy$ = new Subject();
    selectedModuleName = "";
    selectedOrganisationName = "";
    checkStateSubscription;
    isCurrentStepEnd = false;
    jobCurrentStepsSubscription;
    getCurrentStepsSubscription;
    getMoveToStepsSubscription;
    getAdHocMoveToWorkflowStepObservableSubscription;
    listenForRouteParamChangesSubscription;
    currentModule;
    currentJobId;
    nextSteps;
    isNotSmallMobileDevice = true;
    subscriptions = {};
    dialogOptions = {
        size: "lg",
        centered: true,
        backdrop: "static",
    };
    applicationWithdrawalReason = ViewApplicationContentMenuConstants.APPLICATION_WITHDRAWAL_REASON;
    withdrawBtnPlaceholder = ViewApplicationContentMenuConstants.WITHDRAW_BTN_PLACEHOLDER;
    confirmDialogBody = ViewApplicationContentMenuConstants.CONFIRM_DIALOG_BODY;
    WORKFLOW_STEP_TYPE_END = ViewApplicationContentMenuConstants.WORKFLOW_STEP_TYPE_END;
    constructor(router, userInformationService, routerParamsService, route, modalService, appController, jobService, currentStepService, changeDetectorRef, viewApplicationService, viewContainerRef, appControllerService, requestStatusService) {
        this.router = router;
        this.userInformationService = userInformationService;
        this.routerParamsService = routerParamsService;
        this.route = route;
        this.modalService = modalService;
        this.appController = appController;
        this.jobService = jobService;
        this.currentStepService = currentStepService;
        this.changeDetectorRef = changeDetectorRef;
        this.viewApplicationService = viewApplicationService;
        this.viewContainerRef = viewContainerRef;
        this.appControllerService = appControllerService;
        this.requestStatusService = requestStatusService;
        this.selectedModule = this.userInformationService.getModuleInformation(+this.appControllerService.selectedModuleID);
        this.selectedModuleName = this.selectedModule?.name;
        this.selectedOrganisationName = this.selectedModule?.organisation?.name;
        this.checkState();
    }
    ngOnInit() {
        this.viewApplicationService.$currentTitlesObservable.subscribe(t => {
            if (t)
                this.pageHeading = t.ViewApplicationTitle;
        });
        this.subscriptions["$isSmallMobileDevice"] = this.appController.$isSmallMobileDevice.subscribe(value => {
            this.isNotSmallMobileDevice = !value;
            this.changeDetectorRef.detectChanges();
        });
        this.listenForRouteParamChanges();
        this.getCurrentStepDetails();
    }
    listenForRouteParamChanges() {
        const onlyValidParams = this.routerParamsService.params.pipe(filter(param => param.moduleid || param.organisationid));
        this.listenForRouteParamChangesSubscription = onlyValidParams.subscribe((params) => {
            if (params) {
                if (params.moduleid) {
                    this.currentJobId = params.jobID;
                    this.userInformationService.$systemModules.pipe(takeUntil(this._destroy$), take(1)).subscribe((modules) => {
                        if (modules !== undefined && modules !== null && modules.length > 0) {
                            this.currentModule = this.userInformationService.getModuleInformation(+params.moduleid);
                        }
                    });
                }
            }
        });
    }
    getCurrentStepDetails() {
        this.getCurrentStepsSubscription = this.currentStepService.getCurrentSteps(+this.currentJobId, this.currentModule.id).subscribe({
            next: (data) => {
                if (data.length > 0 && data[0].type === "End") {
                    this.isCurrentStepEnd = true;
                }
                else {
                    this.isCurrentStepEnd = false;
                }
                this.changeDetectorRef.detectChanges();
            },
            error: error => {
                this.appController.handleServerErrorMessage(ViewApplicationStepManagementConstants.COMPONENT_NAME, error, CRUDOperation.Get);
            }
        });
    }
    routeToMenuItem(menuItem) {
        if (this.relativeLinks) {
            this.router.navigate([menuItem.address], { relativeTo: this.route });
        }
        else {
            this.router.navigate([menuItem.address]);
        }
    }
    checkState() {
        if (this.menuItems && this.pageHeading) {
            return;
        }
        const componentRef = this.viewContainerRef.createComponent(StrategyFinderComponent);
        const strategy = componentRef.instance.moduleStrategyService;
        if (strategy.dynamicTitle.ViewApplicationTitle && !this.pageHeading) {
            this.pageHeading = strategy.dynamicTitle.ViewApplicationTitle;
        }
        const emptySpaceRe = new RegExp(" ", "gi");
        const dashRe = new RegExp("-", "gi");
        const slashRe = new RegExp("/", "gi");
        const menuLinks = new Array();
        this.viewApplicationService.viewApplicationMenuLinks = strategy.viewApplicationMenuHeadings;
        const keys = [];
        Object.keys(this.viewApplicationService.viewApplicationMenuLinks).forEach((menuHeadingKey) => {
            keys.push("'" + menuHeadingKey + "'");
            const linkRoute = this.viewApplicationService.viewApplicationMenuLinks[menuHeadingKey].toLocaleLowerCase();
            if (strategy.name === ModuleConfig.Cemetery) {
                menuLinks.push({
                    text: menuHeadingKey.replace("Agent", ""),
                    address: linkRoute.toLowerCase().replace(emptySpaceRe, "").replace(dashRe, "").replace(slashRe, ""),
                    key: menuHeadingKey
                });
            }
            else {
                menuLinks.push({
                    text: this.viewApplicationService.viewApplicationMenuLinks[menuHeadingKey],
                    address: linkRoute.toLowerCase().replace(emptySpaceRe, "").replace(dashRe, "").replace(slashRe, ""),
                    key: menuHeadingKey
                });
            }
        });
        const params = {
            $filter: `moduleId eq ${this.appControllerService.selectedModuleID} and key in (${keys.join(",")})`
        };
        this.viewApplicationService.getModuleSettings(params).subscribe(response => {
            const settings = response?.value || [];
            const menuLinkItems = [];
            menuLinks.forEach((menuLink) => {
                let foundSetting = null;
                settings.forEach((setting) => {
                    if (menuLink.key !== undefined && menuLink.key !== null
                        && setting.key !== undefined && setting.key !== null
                        && menuLink.key.toLowerCase() === setting.key.toLowerCase()) {
                        foundSetting = setting;
                    }
                });
                if (foundSetting === null || foundSetting.value === "true") {
                    menuLinkItems.push(menuLink);
                }
            });
            this.menuItems = menuLinkItems;
        });
    }
    terminateApplication($event) {
        const modalRef = this.modalService.open(CancelApplicationConfirmationComponent, this.dialogOptions);
        modalRef.componentInstance.title = this.withdrawBtnPlaceholder;
        modalRef.componentInstance.description = this.confirmDialogBody;
        modalRef.result.then(response => {
            if (!response)
                return;
            const withdrawParams = {
                jobId: this.currentJobId,
                moduleId: this.currentModule.id,
                reason: this.applicationWithdrawalReason
            };
            this.requestStatusService.showBusySpinner(this.applicationWithdrawalReason);
            this.viewApplicationService.withdrawApplication(withdrawParams)
                .pipe(take(1), switchMap(() => this.currentStepService.getCurrentSteps(+this.currentJobId, this.currentModule.id)))
                .subscribe({
                next: (data) => {
                    this.viewApplicationService.updateTracker();
                    if (data.length > 0 && data[0].type === this.WORKFLOW_STEP_TYPE_END) {
                        this.isCurrentStepEnd = true;
                    }
                    else {
                        this.isCurrentStepEnd = false;
                    }
                    this.requestStatusService.removeBusySpinner(this.applicationWithdrawalReason);
                    this.appController.showMessage(ViewApplicationStepManagementConstants.WITHDRAW_SUCCESS_MESSAGE, AlertType.Success);
                    this.changeDetectorRef.detectChanges();
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner(this.applicationWithdrawalReason);
                    this.appController.handleServerErrorMessage(ViewApplicationStepManagementConstants.COMPONENT_NAME, error, CRUDOperation.Get);
                }
            });
        });
    }
    static ctorParameters = () => [
        { type: Router },
        { type: UserInformationService },
        { type: RouterParamsService },
        { type: ActivatedRoute },
        { type: NgbModal },
        { type: AppControllerService },
        { type: WorkflowJobService },
        { type: CurrentStepService },
        { type: ChangeDetectorRef },
        { type: ViewApplicationService },
        { type: ViewContainerRef },
        { type: AppControllerService },
        { type: RequestStatusService }
    ];
    static propDecorators = {
        pageHeading: [{ type: Input }],
        menuItems: [{ type: Input }],
        relativeLinks: [{ type: Input }]
    };
};
ViewApplicationContentMenuComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-content-menu",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationContentMenuComponent);
export { ViewApplicationContentMenuComponent };
